import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGames, gameDeleted } from "../../redux/gamesSlice";
import AdminNavMain from "./AdminNavComponent";
import AdminStats from "./AdminStatsComponent";
import { useAuth0 } from "@auth0/auth0-react";

function GameAdmin(){

    const deleteGame = async (event) => {
        const deletePromiseResponse = await fetch(process.env.REACT_APP_DATABASE_URL + '/games', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                gameId: event.target.dataset.gameId
            })
        });
        const deleteResponse = await deletePromiseResponse.json();

        if(deleteResponse.success){
            dispatch(gameDeleted(deleteResponse.game_id));
            alert(deleteResponse.message);
        } else if (deleteResponse.message) {
            alert(deleteResponse.message);
        } else if (deleteResponse.description){
            alert("Issue deleting game entry: " + deleteResponse.description)
        } else {
            alert(`Error: ${deleteResponse.error}. ${deleteResponse.status}`);
        }

    };

    const dispatch = useDispatch();

    const [accessToken, setAccessToken] = useState('emptyTokenInAdmin');
    const {getAccessTokenSilently} = useAuth0();

    useEffect(() => {

        const getAccessToken = async () => {
            try {
                const jwt = await getAccessTokenSilently()
                setAccessToken(jwt);
                dispatch(fetchGames(jwt));
            } catch (e) {
                // token retrieval failed
            }
        };

        getAccessToken();

    }, [getAccessTokenSilently, dispatch]);

    const listGames = useSelector(state => state.games.gamesArray);

    const gamesListCards = listGames.map((game) => {
        return(
            <div className="border border-gray-200 rounded bg-white p-4 shadow-sm" key={game.id}>
                <h5 className="font-semibold text-lg mb-2">Game id: {game.id}</h5>
                <p className="text-sm text-gray-700">
                    <b>User id:</b> {game.user_id}<br /><br />
                    <b>Quiz id:</b> {game.quiz_id}<br /><br />
                    <b>Score:</b> {game.score}<br /><br />
                    <b>Timestamp:</b><br />{game.timestamp}
                </p>
                <button
                    className="mt-2 px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                    data-game-id={game.id}
                    onClick={deleteGame}>
                        Delete
                </button>
            </div>
        )
    });

    const gamesListTable = listGames.map((game) => {
        return(
            <tr key={game.id} className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-4 py-2 text-sm font-medium">{game.id}</td>
                <td className="px-4 py-2 text-sm">{game.user_id}</td>
                <td className="px-4 py-2 text-sm">{game.quiz_id}</td>
                <td className="px-4 py-2 text-sm">{game.score}</td>
                <td className="px-4 py-2 text-sm">{game.timestamp}</td>
                <td className="px-4 py-2">
                    <button
                        className="px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                        data-game-id={game.id}
                        onClick={deleteGame}>
                            Delete
                    </button>
                </td>
            </tr>
        )
    });

    return(
        <>
            <AdminNavMain />
            <div className="max-w-7xl mx-auto px-4 pt-16">
                <h1 className="text-2xl font-bold text-gray-800 my-4">Game Admin</h1>
            </div>
            <AdminStats />
            <div className="max-w-7xl mx-auto px-4">
                {/* Table view for md+ */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-100 border-b-2 border-gray-300">
                                <th className="px-4 py-2 text-sm font-semibold">Game id</th>
                                <th className="px-4 py-2 text-sm font-semibold">User id</th>
                                <th className="px-4 py-2 text-sm font-semibold">Quiz id</th>
                                <th className="px-4 py-2 text-sm font-semibold">Score</th>
                                <th className="px-4 py-2 text-sm font-semibold">Timestamp</th>
                                <th className="px-4 py-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {gamesListTable}
                        </tbody>
                    </table>
                </div>
                {/* Card view for mobile */}
                <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {gamesListCards}
                </div>
            </div>
        </>
    );
};

export default GameAdmin;
